import { intl } from '@/intl'

export const getAddNewTimeWindowText = () => intl.translate({ id: 'components.timeWindows.addNew' })
